module.exports = __webpack_public_path__ + "static/media/trash386ad7af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/trash.svg
// module id = 349
// module chunks = 0